import { path, pathOr, cond, T, mergeDeepRight } from 'ramda'
import { defaultFilters } from '../../utils'

export const stateFacetField = 'facilities.state_name'
const otherStateFacetField = 'other_states'

export const getSuggestionText = cond([
  [({ type }) => type === 'state', ({ value }) => `${value}, United States`],
  [({ state }) => state, ({ value, state }) => `${value}, ${state}`],
  [T, ({ value }) => value]
])

const FILTERS = {
  places: ({ lat, lng, ...props }) => {
    return {
      page: 1,
      configure: {
        aroundLatLng: `${lat}, ${lng}`,
        value: getSuggestionText(props),
        filters: defaultFilters
      }
    }
  },
  state: ({ value }) => ({
    page: 1,
    configure: {
      value: `${value}, United States`,
      filters: `${defaultFilters} AND (${otherStateFacetField}:"${value}" OR ${stateFacetField}:"${value}")`
    }
  })
}

export const getFilterBy = (type) => FILTERS[type]

const setFieldValues = (paths) => (obj) => {
  const result = {}

  for (const [pathDef, fieldValue] of paths) {
    const [k1, k2] = pathDef

    if (path(pathDef, obj)) {
      result[k1] = {
        [k2]: fieldValue
      }
    }
  }
  return result
}

// only allow one type to be filtered - reset to default value for unselected filters
const overrideOptions = (searchState, type) => {
  const latLngPath = ['configure', 'aroundLatLng']
  const statePath = ['configure', 'filters']

  const typeOptions = {
    places: setFieldValues([
      [statePath, defaultFilters]
    ]),
    state: setFieldValues([
      [latLngPath, null]
    ])
  }

  return typeOptions[type](searchState)
}

export const getNextState = (searchState, updatedState, type) => {
  const nextState = mergeDeepRight(searchState, updatedState)
  return mergeDeepRight(nextState, overrideOptions(searchState, type))
}
export const getSuggestionValue = ({ searchState, history }) => pathOr(
  path(['location', 'state', 'locationValue'], history),
  ['configure', 'value'],
  searchState
)
